import React, { useState } from "react"
import '../assets/scss/pages/members.scss'

import { Link } from "gatsby"
import { ERoutes } from "../types"
import { getRoute } from "../helpers"

import DefaultLayout from "../layouts/DefaultLayout"
import Chapter from "../components/atoms/Chapter"

const Members: React.FC<any> = (props) => {

	const [route] = useState(getRoute(ERoutes.Member))

	return (
		<DefaultLayout
			{...props}
			route={route}
			title='会員募集｜第2750地区東京中央ロータリークラブ'
		>
			<div className='members'>
				<div id="comment">
					<h2 className="title">～あなたも「東京中央ロータリークラブ」の仲間に入りませんか！～</h2>
					<div className="inner">
						<div className="logo">
							<img src="/images/RotaryLogo.svg" width="262" height="262" alt="" />
						</div>
						<div className="text">
							「東京中央ロータリークラブ」は、各界から２０代～９０代まで約２００名の幅広い会員から構成されており、<strong>「和気あいあい　多士さいさい」</strong>をモットーに、
							会員相互の親睦活動や活発なクラブ同好会活動などを積極的に行う一方、創立以来社会奉仕活動にも力を入れており、地域や社会へ様々な実績があります。<br />
							本年34周年を迎え、さらなる飛躍、社会への還元を目指し同士を求めております。<br />
							我々の活動にご賛同頂ける皆様、是非ロータリアンとして活動をしてみませんか！
							<p className="bana">
								<Link to='/club'>
									<i className="outline">クラブ概要</i>
								</Link>
							</p>
						</div>
					</div>
				</div>
				<p id="bana">
					<a href="/downloads/mousikomi201404.pdf" target="_blank">
						<img
							src="/images/members/fax.gif"
							width="358"
							height="67"
							alt="申込ＦＡＸ用紙ダウンロード"
						/>
					</a>
					<a href="/downloads/EntryForm.doc" target="_blank">
						<img
							src="/images/members/word.gif"
							width="358"
							height="67"
							alt="メール申込用Wordファイルダウンロード"
						/>
					</a>
				</p>
				<div id="member">
					<div id="tokuchou" className="item">
						<Chapter title='東京中央ロータリークラブの特徴と魅力' />
						<div className='mt-4'>
							<div className="photo">
								<img src="/images/banner.gif" width="168" height="254" alt="" />
							</div>
							<ul className="text">
								<li>①200名を超える会員を擁する世界でも有数のクラブです。日本では３本指に入る大クラブで、日本を代表して国際ロータリー大規模クラブ会議にも出席しています。</li>
								<li>②会員は様々な業種のトップ経営者などの実業人、医師、弁護士、公認会計士、文筆家、コンサルタントなどの専門業種人など多士さいさいで、魅力あふれる人達です。 </li>
								<li>③例会は気品あふれる帝国ホテルで、素晴らしいお食事と各界名士の卓話を楽しみながら行われます。会員同士の情報交換や新たな活動の企画などが積極的に行われます。 </li>
								<li>④協力して息の長い奉仕活動を行うことにより、地域社会や国際社会に貢献する喜びを味わうことができます。 </li>
								<li>⑤ゴルフ同好会、つり同好会、トレッキング同好会、囲碁同好会、水墨画同好会、旨いもの同好会等、同好会活動も活発で、好評です。 </li>
							</ul>
						</div>
					</div>

					<div id="shikaku" className="item">
						<Chapter title='会員の資格' />
						<div className='mt-4'>
							<div className="photo">
								<img src="/images/members/shikaku-image.gif" width="259" height="193" alt="" />
							</div>
							<div className="text">
								良識ある社会人であり善良な家庭人。<br />
								社会の第一線で活躍している実業人、専門業種人。<br />
								職業や奉仕活動などを通して社会の人々に貢献したいと考えている人。
							</div>
						</div>
					</div>

					<div id="tokuten" className="item">
						<Chapter title='会員の特典' />

						<div className="inner mt-4">
							<div className="ico">
								<img
									src="/images/members/houshi.png"
									width="93"
									height="93"
									alt="奉仕"
								/>
							</div>
							<div className="text">
								個人ではできない奉仕活動を協力して行うことにより、地域社会や国際社会に大きな貢献をすることができます。
							</div>
						</div>
						<div className="inner">
							<div className="ico">
								<img src="/images/members/shinboku.png" width="93" height="93" alt="親睦" />
							</div>
							<div className="text">
								様々な分野で活躍中の多くの優れた人々との出会い、交流、親睦を深めることができます。<br />
								毎週の例会で、著名人の卓話、会員のイニシェーションスピーチなど素晴らしい公演が聴けます。<br />
								日本全国及び世界各地のロータリークラブの例会に出席が出来、より広く交流と親睦を深めることが出来ます。<br />
							</div>

						</div>

						<div id="gimu" className="item">
							<Chapter title='会員の義務' />
							<div className='mt-4 text-center'>
								<img
									width="777"
									height="159"
									src="/images/members/gimu_zu.png"
									alt="会費の納入・例会への出席・機関誌の購読"
								/>
							</div>
						</div>
						<div id="kaihi" className="item">
							<Chapter title='会費' />
							<p className='mt-4'>入会金：30万円<br />年会費：30万円を2回に分けて納入（夜間例会などは別途料金）</p>
						</div>
						<div id="flow" className="item">
							<Chapter title='入会の流れ' />
							<div className='mt-4'>
								<img
									width="938"
									height="151"
									src="/images/members/flow_zu.png"
									alt="事前説明→入会申込み→理事会承認→入会→登録・バッジ交付・会費納入"
								/>
							</div>
						</div>
						<div id="toi" className="item">
							<img src="/images/members/toi.gif" alt="" width="942" height="260" useMap="#Map" />
							<map name="Map">
								<area
									shape="rect"
									coords="261,164,749,192"
									href="m&#97;&#105;lt&#111;&#58;&#106;&#105;muky&#111;ku&#64;tok&#121;&#111;&#99;&#104;u&#111;-r&#111;&#116;&#97;&#114;&#121;&#46;&#111;r&#103;"
								/>
								<area shape="rect" coords="267,198,736,228" href="http://www.tokyochuo-rotary.org" />
							</map>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	)
}

export default Members
